import { SERVER_TYPE } from '../../settings/constants';

const prefixAuth: string = '';
const prefixUser: string = '/users';

const endpointAuth = {
  LOGIN: `${prefixAuth}/api/login/`,
  ME: `${prefixAuth}/me`,
  GET_TOKEN: `${prefixAuth}/oauth/token`
};

const endpointBase = {
  NOTIFICATION: `/api/notifications`
};

const endpointOther = {
  UPLOAD_IMG: `${prefixAuth}/upload`,
  UPLOAD_FILE: `${prefixAuth}/file/upload`
};

const endpointUser = {
  GET_USERS: `${prefixUser}/getAllUser`,
  ADD_USER: `${prefixUser}/addUser`,
  GET_DETAIL: `${prefixUser}/getUserDetail`,
  CHANGE_USER_DATA: `${prefixUser}/changeUserInfo`,
  DELETE_USER_DATA: `${prefixUser}/deleteUser`,
  UPDATE_USER_PASSWORD: `${prefixUser}/changePassword`,
  CHANGE_PASSWORD_OF_USER: `${prefixUser}/changePasswordOfUser`
};

const endpointCategory = {
  GET_DEPARTMENTS: `/api/departments/`,
  GET_MACHINES: `/api/machines/`,
  GET_CATEGORY_MACHINES: `/api/category-machines/`,
  GET_PROTOCOLS: `/api/protocols/`,
  GET_CONNECTION_PROFILES: `/api/connection-profiles/`,
  GET_TAG_DEFINITIONS: `/api/tag-definitions/`,
  GET_LIVE_TAGS: `/api/live-tags/`,
  GET_METRIC_VALUES: `/api/metric-values/`,
  GET_METRIC_VALUES_HISTORY: `/api/metric-values/history/`,
  GET_METRIC_VALUES_GREATER_THAN: `/api/metric-values/greater-than/`,
  GET_CONNECTION_PROFILE_PORTS: (machineId: string) => `/api/machines/${machineId}/connection-profile-ports/`,
  GET_MACHINE_CONNECTION_PROFILES: (machineId: string) => `/api/machines/${machineId}/connection-profiles/`,
  GET_DECODER_METRIC_VALUES: (profileId: string, port: string | number, decoder: string) => `/api/connection-profiles/${profileId}/ports/${port}/decoders/${decoder}/metric-values/`,
  GET_DECODER_TIME_STATISTICS: (profileId: string, port: string | number, decoder: string) => `/api/connection-profiles/${profileId}/ports/${port}/decoders/${decoder}/time-statistics/`,
  GET_TAG_OPERATION_STATISTICS: (tagId: string) => `/api/tags/${tagId}/operation-statistics/`,
  GET_MAIL_SENSOR_CONFIGS: `/api/mail-sensor-configs/`,
  GET_MAIL_HISTORIES: `/api/mail-histories/`,
  GET_MAIL_HISTORY_DETAIL: (id: string) => `/api/mail-histories/${id}/`,
  GET_MAIL_HISTORY_CONTENT_DETAIL: (id: string) => `/api/mail-histories/${id}/content-detail/`,
  GET_SENSOR_CHANGE_PERCENT: `/api/sensor/change-percent/`,
  GET_SENSOR_HISTORY: `/api/sensor/history`
};

export {
  endpointAuth,
  endpointBase,
  endpointOther,
  endpointUser,
  endpointCategory
};
